import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "drop-down-rule",
  "data-cy": "rule-value-selection"
}
const _hoisted_2 = {
  key: 0,
  class: "status-entry"
}
const _hoisted_3 = { class: "entry-text" }
const _hoisted_4 = {
  key: 0,
  class: "status-entry"
}
const _hoisted_5 = { class: "entry-text" }

import MSelect from "@/BasicComponentLibrary/MSelect.vue";
import { SelectionListModel } from "@medapro-types/AdvancedSearch/components/QueryBuilder";
import _ from "lodash";
import { computed } from "vue";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'DropDownRule',
  props: {
    value: {},
    items: { default: () => [] }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;



//#endregion

//#region items
const currentIdFieldName = computed(() => {
  const firstElement = _.first(props.items);
  if (firstElement) {
    const foundIdName = Object.keys(firstElement).find((x) => x.endsWith("Id"));
    if (foundIdName) return foundIdName;
  }
  return null;
});
//#endregion

//#region Update localModal
const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});

//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentIdFieldName.value)
      ? (_openBlock(), _createBlock(MSelect, {
          key: 0,
          modelValue: localModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModel).value = $event)),
          items: _ctx.items,
          "text-field": "name",
          "display-field": "name",
          "value-field": currentIdFieldName.value
        }, {
          "button-content": _withCtx(({ selectedItem }) => [
            _renderSlot(_ctx.$slots, "button-content", { entry: selectedItem }, () => [
              (selectedItem && selectedItem.color)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", {
                      class: "color-block",
                      style: _normalizeStyle({ backgroundColor: `#${selectedItem.color.substring(2, selectedItem.color.length)}` })
                    }, null, 4),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(selectedItem?.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(selectedItem?.name), 1)
                  ], 64))
            ])
          ]),
          "item-template": _withCtx(({ entry }) => [
            _renderSlot(_ctx.$slots, "default", { entry: entry }, () => [
              (Object.hasOwn(entry, 'color'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (entry.color)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "color-block",
                          style: _normalizeStyle({ backgroundColor: `#${(<SelectionListModel>entry).color!.substring(2, (<SelectionListModel>entry).color!.length)}` })
                        }, null, 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(entry.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(entry.name), 1)
                  ], 64))
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "items", "value-field"]))
      : _createCommentVNode("", true)
  ]))
}
}

})